(() => {
  const start=Date.parse('2026-10-03T00:00:00-06:00');
  const end=Date.parse('2026-10-05T00:00:00-06:00');
  const banners=document.querySelectorAll('[data-cfvm-anniversary]');
  if(!banners.length)return;
  function tick(){
    const now=Date.now(),active=now>=start&&now<end;
    document.querySelectorAll('[data-cfvm-sale-badge]').forEach(el=>el.hidden=!active);
    banners.forEach(banner=>{
      banner.hidden=!active;
      if(!active)return;
      const total=Math.max(0,Math.floor((end-now)/1000));
      const parts={days:Math.floor(total/86400),hours:Math.floor(total/3600)%24,minutes:Math.floor(total/60)%60,seconds:total%60};
      Object.entries(parts).forEach(([key,value])=>{const field=banner.querySelector('[data-'+key+']');if(field)field.textContent=String(value).padStart(2,'0');});
    });
  }
  tick();setInterval(tick,1000);
})();
